import { useEffect, useState } from "react";
import { CheckIcon } from "src/assets/icons";
import { GhostButton } from "src/components/Buttons";
import { ApplicationStatusList } from "src/constants";
import {
  StatusListContainer,
  StatusRow,
  StyledCheckbox,
  StyledCheckboxIndicator,
  TitleLabel,
} from "./StatusSelector.styles";
import { ApplicationStatusBadge } from "../ApplicationStatusBadge";
import type { AppMilestoneType } from "../ApplicationStatusBadge";

const toggleStatusInArray = (status: string, arr: string[]): string[] => {
  if (arr.includes(status)) {
    return arr.filter((str) => str !== status);
  } else {
    return [...arr, status];
  }
};

interface StatusSelectorProps {
  showMenu: boolean;
  selectedStatuses: string[];
  setSelectedStatuses: (statuses: string[]) => void;
}

// TODO: we don't actually need a checkbox here after all, it's just a
// checkbox looking indicator. Lets rip it out in the future
export default ({
  showMenu,
  selectedStatuses,
  setSelectedStatuses,
}: StatusSelectorProps) => {
  const [userChoices, setUserChoices] = useState<string[]>(selectedStatuses);
  useEffect(() => {
    setUserChoices(selectedStatuses);
  }, [selectedStatuses]);
  return (
    <StatusListContainer show={showMenu}>
      <TitleLabel>You can select multiple</TitleLabel>
      {ApplicationStatusList.map((status) => (
        <StatusRow
          key={status}
          role="button"
          tabIndex={0}
          onClick={() =>
            setUserChoices((prev) => toggleStatusInArray(status, prev))
          }
        >
          <StyledCheckbox checked={userChoices.includes(status)}>
            <StyledCheckboxIndicator>
              <CheckIcon />
            </StyledCheckboxIndicator>
          </StyledCheckbox>
          <ApplicationStatusBadge status={status as AppMilestoneType} />
        </StatusRow>
      ))}
      <GhostButton onClick={() => setSelectedStatuses(userChoices)}>
        Apply
      </GhostButton>
    </StatusListContainer>
  );
};
